import * as React from 'react';

export function useIsCollapsed() {
  const [isCollapsed, setIsCollapsed] = React.useState(true);
  const toggleCollapsedHandler = () => setIsCollapsed((isCollapsed) => !isCollapsed);

  return { isCollapsed, toggleCollapsedHandler } as const;
}
